export default __webpack_public_path__ + "static/media/pie-delegation.6fe737f1.svg";